<template>
    <div>
        <h2 class="font-bold text-gray-700">Listado de ordenes de compra</h2>
      <MainListPurchaseOrder />
    </div>
  </template>
  
  <script>
  import MainListPurchaseOrder from "@/components/PurchaseOrder/Main/MainListPurchaseOrder.vue";
import { useRoute } from 'vue-router';
import { onBeforeMount, onMounted } from 'vue';
import { findSubmoduleIdByDescription } from '@/hisAcces';
  export default {
    name: "ListPurchaseOrder",
    components: {
        MainListPurchaseOrder,
    },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
  };
  </script>
  